const getters = {
  menuList: state => state.user.menuList,
  userInfo: state => state.user.userInfo,
  permissionList: state => state.user.permissionList,
  userInfoLoaded: state => state.user.userInfoLoaded
}
export default getters
